import { FC } from "react";
import { useTranslation } from "react-i18next";

interface IStationTimingPreviewToolbarProps {
  onSelectAllMedian: () => void;
  onSelectAllAverage: () => void;
  onClearSelection: () => void;
}

/** The three actions that rewrite the whole selection at once, grouped as one named control set. */
export const StationTimingPreviewToolbar: FC<
  IStationTimingPreviewToolbarProps
> = ({ onSelectAllMedian, onSelectAllAverage, onClearSelection }) => {
  const { t } = useTranslation();

  return (
    <div
      className="station-timing__toolbar"
      role="group"
      aria-label={t("stationTiming.BULK_ACTIONS")}
    >
      <button
        type="button"
        className="station-timing__bulk-button"
        onClick={onSelectAllMedian}
      >
        {t("stationTiming.SELECT_ALL_MEDIAN")}
      </button>
      <button
        type="button"
        className="station-timing__bulk-button"
        onClick={onSelectAllAverage}
      >
        {t("stationTiming.SELECT_ALL_AVERAGE")}
      </button>
      <button
        type="button"
        className="station-timing__bulk-button"
        onClick={onClearSelection}
      >
        {t("stationTiming.CLEAR_SELECTION")}
      </button>
    </div>
  );
};
